import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import axios from "../lib/axios";
import { API_BASE_URL } from '../config';
import { Loader2 } from "lucide-react";

const SessionInfo: React.FC = () => {
    const [loading, setLoading] = useState(false);

    const handleGetSession = async () => {
        setLoading(true);
        try {
            // Call the same API used in PersonalInfo.tsx
            const res = await axios.post(`${API_BASE_URL}/api/initiate_digilocker_verification/`, {}, { maxRedirects: 0 });
            const details = res.data;

            const message = [
                "User Profile Details (from API):",
                `Name: ${details.individual_name || 'N/A'}`,
                `Phone: ${details.phone_number || 'N/A'}`,
                `PAN: ${details.individual_pan_number || 'N/A'}`,
                `DOB: ${details.date_of_birth || 'N/A'}`,
                `Gender: ${details.gender || 'N/A'}`,
            ].join("\n");

            alert(message);
        } catch (err: any) {
            console.error("Error fetching individual details:", err);
            alert("Error fetching session details: " + (err.response?.data?.detail || err.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
            <div className="bg-white p-8 rounded-xl shadow-lg text-center max-w-md w-full border border-gray-100">
                <h1 className="text-2xl font-bold mb-6 text-gray-800">Complete Session Profile</h1>
                <p className="text-gray-600 mb-8">
                    Click the button below to fetch and view your comprehensive session and profile information.
                </p>
                <Button
                    id="get-user-session"
                    onClick={handleGetSession}
                    disabled={loading}
                    className="w-full bg-primary hover:bg-primary/90 text-white font-medium py-2 rounded-lg transition-all duration-200 flex items-center justify-center gap-2"
                >
                    {loading ? (
                        <>
                            <Loader2 className="h-4 w-4 animate-spin" />
                            Connecting to digilocker ...
                        </>
                    ) : (
                        "get-user-session"
                    )}
                </Button>
            </div>
        </div>
    );
};

export default SessionInfo;
